import { useRef } from "react";
import { type LottieRefCurrentProps } from "lottie-react";
import { useBreakpointsViews } from "components";
import GenreAnimatedIcon from "components/GenreAnimatedIcon";
import Card from "./Card";

import styles from "./GenreCard.module.scss";

interface GenreCardProps {
  id: string | number;
  name: string;
}

const GenreCard = ({ id, name }: GenreCardProps) => {
  const genreAnimatedIcon = useRef<LottieRefCurrentProps>(null);
  const { isDesktop } = useBreakpointsViews();

  const handleMouseEnter = () => {
    genreAnimatedIcon.current?.play();
  };

  const handleMouseLeave = () => {
    genreAnimatedIcon.current?.stop();
  };

  return (
    <Card
      className={styles.card}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isDesktop && (
        <div className={styles.icon}>
          <GenreAnimatedIcon
            ref={genreAnimatedIcon}
            genreId={id}
            loop={false}
            autoplay={false}
          />
        </div>
      )}

      <span className={styles.name}>{name}</span>
    </Card>
  );
};

export default GenreCard;
